import { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableListItem = ({ id, url, onDelete }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const dynamicStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <>
      <div
        ref={setNodeRef}
        style={dynamicStyle}
        className={`w-full aspect-square bg-white border-2 border-gray-100 rounded-lg overflow-hidden
          flex flex-col items-center justify-center relative
          ${isDragging ? "opacity-50 z-[100]" : "opacity-100 z-auto"} group`}
      >
        <button
          {...listeners}
          {...attributes}
          className="absolute top-2 left-2 p-1 text-xs bg-white/50 rounded"
        >
          Drag
        </button>
        <img
          src={url}
          alt="preview"
          className="w-full h-full object-contain cursor-pointer"
          onClick={() => setIsPreviewOpen(true)}
        />
        <button
          onClick={onDelete}
          className="absolute bottom-2 bg-black bg-opacity-60 text-white rounded-full px-2 py-1 text-xs opacity-0 group-hover:opacity-100 transition"
        >
          delete
        </button>
      </div>
      {isPreviewOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setIsPreviewOpen(false)}
        >
          <img
            src={url}
            alt="fullscreen-preview"
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </>
  );
};

export default SortableListItem;
